// import React from "react";
// import ProfileDropdown from "../Common/ProfileDropdown";
// import NotificationDropdown from "../Common/NotificationDropdown";
// import { Button } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import logolight from "../assets/images/mayaveLogo.svg";
// import StoreChangeSelectComponent from "Common/StoreChangeSelectComponent";

// const toogleMenuBtn = () => {
//   var windowSize = document.documentElement.clientWidth;

//   if (windowSize > 767)
//     document.querySelector(".hamburger-icon")?.classList.toggle("open");

//   //For collapse horizontal menu
//   if (document.documentElement.getAttribute("data-layout") === "horizontal") {
//     document.body.classList.contains("menu")
//       ? document.body.classList.remove("menu")
//       : document.body.classList.add("menu");
//   }

//   //For collapse vertical menu
//   if (document.documentElement.getAttribute("data-layout") === "vertical") {
//     if (windowSize < 1025 && windowSize > 767) {
//       document.body.classList.remove("vertical-sidebar-enable");
//       document.documentElement.getAttribute("data-sidebar-size") === "sm"
//         ? document.documentElement.setAttribute("data-sidebar-size", "")
//         : document.documentElement.setAttribute("data-sidebar-size", "sm");
//     } else if (windowSize > 1025) {
//       document.body.classList.remove("vertical-sidebar-enable");
//       document.documentElement.getAttribute("data-sidebar-size") === "lg"
//         ? document.documentElement.setAttribute("data-sidebar-size", "sm")
//         : document.documentElement.setAttribute("data-sidebar-size", "lg");
//     } else if (windowSize <= 767) {
//       document.body.classList.add("vertical-sidebar-enable");
//       document.documentElement.setAttribute("data-sidebar-size", "lg");
//     }
//   }

//   //Two column menu
//   if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
//     document.body.classList.contains("twocolumn-panel")
//       ? document.body.classList.remove("twocolumn-panel")
//       : document.body.classList.add("twocolumn-panel");
//   }
// };

// const Header = () => {
//   return (
//     <React.Fragment>
//       <header id="page-topbar">
//         <div className="layout-width">
//           <div className="navbar-header">
//             <div className="d-flex">
//               <div className="navbar-brand-box horizontal-logo ps-2">
//                 <Link to={"/dashboard"} className="logo logo-dark"></Link>

//                 <Link to={"/dashboard"} className="logo logo-light">
//                   <span className="logo-lg">
//                     <img src={logolight} alt="" height="35" />
//                   </span>
//                 </Link>
//               </div>

//               <Button
//                 variant="link"
//                 size="sm"
//                 type="button"
//                 className="px-1 fs-lg header-item vertical-menu-btn topnav-hamburger shadow-none"
//                 id="topnav-hamburger-icon"
//                 onClick={toogleMenuBtn}
//               >
//                 <i className=" bx bx-menu-alt-left fs-2"></i>
//               </Button>
//             </div>

//             <div className="d-flex align-items-center">
//               <StoreChangeSelectComponent />
//               <ProfileDropdown />
//               {/* <NotificationDropdown /> */}
//             </div>
//           </div>
//         </div>
//       </header>

//       <div
//         id="removeNotificationModal"
//         className="modal fade zoomIn"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//                 id="NotificationModalbtn-close"
//               ></button>
//             </div>
//             <div className="modal-body p-md-5">
//               <div className="text-center">
//                 <div className="text-danger">
//                   <i className="bi bi-trash display-4"></i>
//                 </div>
//                 <div className="mt-4 fs-md">
//                   <h4 className="mb-1">Are you sure ?</h4>
//                   <p className="text-muted mx-4 mb-0">
//                     Are you sure you want to remove this Notification ?
//                   </p>
//                 </div>
//               </div>
//               <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
//                 <button
//                   type="button"
//                   className="btn w-sm btn-light"
//                   data-bs-dismiss="modal"
//                 >
//                   Close
//                 </button>
//                 <button
//                   type="button"
//                   className="btn w-sm btn-danger"
//                   id="delete-notification"
//                 >
//                   Yes, Delete It!
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </React.Fragment>
//   );
// };

// export default Header;

import React, { useState } from "react";
import ProfileDropdown from "../Common/ProfileDropdown";
import NotificationDropdown from "../Common/NotificationDropdown";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import logolight from "../assets/images/mayaveLogo.svg";
import StoreChangeSelectComponent from "Common/StoreChangeSelectComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";

const toogleMenuBtn = () => {
  var windowSize = document.documentElement.clientWidth;

  if (windowSize > 767)
    document.querySelector(".hamburger-icon")?.classList.toggle("open");

  //For collapse horizontal menu
  if (document.documentElement.getAttribute("data-layout") === "horizontal") {
    document.body.classList.contains("menu")
      ? document.body.classList.remove("menu")
      : document.body.classList.add("menu");
  }

  //For collapse vertical menu
  if (document.documentElement.getAttribute("data-layout") === "vertical") {
    if (windowSize < 1025 && windowSize > 767) {
      document.body.classList.remove("vertical-sidebar-enable");
      document.documentElement.getAttribute("data-sidebar-size") === "sm"
        ? document.documentElement.setAttribute("data-sidebar-size", "")
        : document.documentElement.setAttribute("data-sidebar-size", "sm");
    } else if (windowSize > 1025) {
      document.body.classList.remove("vertical-sidebar-enable");
      document.documentElement.getAttribute("data-sidebar-size") === "lg"
        ? document.documentElement.setAttribute("data-sidebar-size", "sm")
        : document.documentElement.setAttribute("data-sidebar-size", "lg");
    } else if (windowSize <= 767) {
      document.body.classList.add("vertical-sidebar-enable");
      document.documentElement.setAttribute("data-sidebar-size", "lg");
    }
  }

  //Two column menu
  if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
    document.body.classList.contains("twocolumn-panel")
      ? document.body.classList.remove("twocolumn-panel")
      : document.body.classList.add("twocolumn-panel");
  }
};
interface HeaderProps {
  onToggleSidebar: () => void;
  isSidebarOpen: boolean;
}

const Header = ({ onToggleSidebar, isSidebarOpen }: HeaderProps) => {
  // const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleToggleSidebar = () => {
    onToggleSidebar();
  };

  const navigate = useNavigate();

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex ms-4">
              <div className="navbar-brand-box horizontal-logo ps-2">
                <Link to={"/dashboard"} className="logo logo-dark"></Link>

                <Link to={"/dashboard"} className="logo logo-light">
                  <span className="logo-lg">
                    <img src={logolight} alt="" height="35" />
                  </span>
                </Link>
              </div>

              {/* <Button
                variant="link"
                size="sm"
                type="button"
                className="px-1 fs-lg header-item vertical-menu-btn topnav-hamburger shadow-none"
                id="topnav-hamburger-icon"
                onClick={toogleMenuBtn}
              >
                <i className=" bx bx-menu-alt-left fs-2"></i>
              </Button> */}
              <Button
                variant="link"
                size="sm"
                type="button"
                className="px-1 ms-4 mb-2 fs-lg header-item vertical-menu-btn topnav-hamburger shadow-none"

                onClick={handleToggleSidebar}
              >
                {/* <i className={`bx ${isSidebarOpen ? "bx-x" : "bx-menu-alt-left"} fs-2`}></i> */}
                <i style={{ color: '#B7002A' }} className={`bx ${isSidebarOpen ? "bx-menu-alt-left" : "bx-menu-alt-left"} fs-2`}></i>
                {/* <i className="bx bx-menu-alt-left fs-2"></i> */}

              </Button>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              <StoreChangeSelectComponent />
              <div className="" style={{ marginLeft: "10px" }}>
                <FontAwesomeIcon style={{ cursor: "pointer" }} icon={faShoppingCart} onClick={() => navigate('/cart-details')} />
              </div>
              <ProfileDropdown />
              {/* <NotificationDropdown /> */}
            </div>
          </div>
        </div>
      </header>

      <div
        id="removeNotificationModal"
        className="modal fade zoomIn"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="NotificationModalbtn-close"
              ></button>
            </div>
            <div className="modal-body p-md-5">
              <div className="text-center">
                <div className="text-danger">
                  <i className="bi bi-trash display-4"></i>
                </div>
                <div className="mt-4 fs-md">
                  <h4 className="mb-1">Are you sure ?</h4>
                  <p className="text-muted mx-4 mb-0">
                    Are you sure you want to remove this Notification ?
                  </p>
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button
                  type="button"
                  className="btn w-sm btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn w-sm btn-danger"
                  id="delete-notification"
                >
                  Yes, Delete It!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Header;